<template>
    <div class="listmain ">
         <h1 class="firTitle">OrionOS账号关联</h1>
              <p>针对于技能开发者需要认证授权的情况，技能开发者可以申请猎户用户中心的账号关联信息，并按照标准的Oauth授权方式进行授权。用户在开放平台配置授权相关信息后，可以获取platformId。
              </p>

              <h5 class="thirdTitle">请求头信息：</h5>
              <p>POST : /intent/invoke HTTP/1.1
                <br>Content-Type : application/x-www-form-urlencoded;charset=UTF-8
                <br>Host : ovs.ainirobot.com
                <br>Content-Length:
                <br>Accept : application/json
                <br>Accept-Charset : utf-8

              </p>
               <h5 class="thirdTitle">请求内容格式规范及参数说明</h5>

              <h5 class="codeTitle">账号关联</h5>
               <highlight-code lang="javascript">
                   "linkAccount":{//Type:JSONObject,关联账号，如果用户没有登录，技能可以追加该Card信息进行LinkAccount功能的引导
                "skillId":"orion.ovs.skill.1510212090177",//Type:String,技能ID
                "platformId":"22", //Type:String,技能的资源平台ID
                "title":"",//Type:String,登录Title
                "subTitle":"",//Type:String,登录二级Title
                "icon":"",//Type:String,登录的Icon图片
                "data":JSONObject//Type:JSONObject,与账号关联相关的业务数据，该字段可以存放埋点需要进行上报的数据
            }


              </highlight-code>


    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 26px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>




// WEBPACK FOOTER //
// src/components/tutor/zdyjn_zhgl.vue